import React from 'react';
import { Dialog, IconButton, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import billKeeperImage from '../../../utilities/images/billKeeper/billKeeper.png';
import billKeeperDialogImage1 from '../../../utilities/images/billKeeper/BillKeeperDialog1.png';
import billKeeperDialogImage2 from '../../../utilities/images/billKeeper/BillKeeperDialog2.png';
import billKeeperDialogImage3 from '../../../utilities/images/billKeeper/BillKeeperDialog3.png';
import billKeeperDialogImage4 from '../../../utilities/images/billKeeper/BillKeeperDialog4.png';
import billKeeperDialogImage5 from '../../../utilities/images/billKeeper/BillKeeperDialog5.png';
import billKeeperDialogImage6 from '../../../utilities/images/billKeeper/BillKeeperDialog6.png';
import ImageCarousel from './ImageCarousel';
import './Projects.css';
import { t } from 'i18next';
import SlideUpTransition from '../SlideUpTransition';

interface BillKeeperDialogProps {
    open: boolean;
    onClose: () => void;
}

const BillKeeperDialog: React.FC<BillKeeperDialogProps> = ({ open, onClose }) => {
    const isCompactScreen = useMediaQuery('(max-width: 768px)');

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={isCompactScreen}
            TransitionComponent={SlideUpTransition}
            sx={{
                '& .MuiDialog-paper': {
                    margin: isCompactScreen ? 0 : 2,
                    width: isCompactScreen ? '100vw' : 'auto',
                    maxWidth: isCompactScreen ? '100vw' : 'min(92vw, 960px)',
                maxHeight: isCompactScreen ? '100dvh' : '95dvh',
                borderRadius: isCompactScreen ? 0 : 3,
                overflow: isCompactScreen ? 'auto' : 'hidden',
            },
        }}
    >
        <div className="card">
            <IconButton aria-label="Close dialog" onClick={onClose} className="dialog-close-button" size="small">
                <CloseIcon fontSize="small" />
            </IconButton>
            
            <div className="title">{t("projectDialogs.billKeeper.title")}</div>
            
            <div className="card-content">
                <ImageCarousel
                    images={[
                        billKeeperImage,
                        billKeeperDialogImage1,
                        billKeeperDialogImage2,
                        billKeeperDialogImage3,
                        billKeeperDialogImage4,
                        billKeeperDialogImage5,
                        billKeeperDialogImage6,
                    ]}
                    alt={t("projectDialogs.billKeeper.title")}
                />
                
                <div className="description">
                    <div className="left-box">
                        {t("projectDialogs.billKeeper.description")}
                    </div>
                    
                    <div className="right-box">
                        <div>{t("projectDialogs.billKeeper.feature1")}</div>
                        <div>{t("projectDialogs.billKeeper.feature2")}</div>
                        <div>{t("projectDialogs.billKeeper.feature3")}</div>
                        <div>Flutter</div>
                        <div>Offline-first</div>
                        <div>Android</div>
                    </div>
                </div>
            </div>
        </div>
    </Dialog>
    );
};

export default BillKeeperDialog;